<ng-container *ngIf="!hideButtons">
    <div class="left">
        <dropdown-menu #menu></dropdown-menu>
        <topbar-context-menu
            *ngIf="menu && menu.dropdown"
            [target]="menu.dropdown"
            [border]="contextMenuBorder"></topbar-context-menu>
        <topbar-breadcrumbs (dblclick)="showButtons = !showButtons"></topbar-breadcrumbs>
        <div
            class="test-buttons"
            *ngIf="showButtons && (!isProd || (isEmployee$ | async))">
            <div
                class="test-button"
                (click)="openCreativeUrl()">
                Preview
            </div>
            <div
                class="test-button"
                *ngIf="isLocal"
                (click)="openMetadataTestUrl()">
                Metadata
            </div>
        </div>
    </div>
    <div class="center">
        <version-picker
            [allowManageVersions]="false"
            (pickerOpen)="onVersionPickerOpen()"
            (pickerClose)="onVersionPickerClose()"
            *ngIf="creativeset">
        </version-picker>
    </div>
    <div class="right">
        <toggle-environment></toggle-environment>

        <current-users></current-users>

        <comments-overview [creativeId]="creativeId"> </comments-overview>

        <ui-button
            *ngIf="showUploadButton$ | async; else saveButtonTpl"
            id="upload-button"
            data-test-id="upload-button"
            type="discrete"
            text="UPLOADING..."
            [disabled]="true"></ui-button>

        <ng-template #saveButtonTpl>
            <ui-button
                id="save-design-button"
                data-test-id="save-design-button"
                #saveButton
                type="primary"
                [text]="saveButtonDisplayText"
                [disabled]="(disabled$ | async)!"
                [loading]="(loading$ | async)!"
                (click)="onSaveButtonClick()"></ui-button>
        </ng-template>

        <ui-help-menu
            (showIntercomNews)="onIntercomNews()"
            (showIntercom)="onIntercom()">
        </ui-help-menu>

        <ui-svg-icon
            uiTooltip="Exit"
            uiTooltipPosition="left"
            class="exit-icon"
            id="exit-editor-button"
            data-test-id="exit-editor-button"
            icon="close"
            fill="#B5B5B5"
            [ngStyle]="{ pointerEvents: (loading$ | async)! ? 'none' : 'auto' }"
            (click)="exit()"
            >done
        </ui-svg-icon>
    </div>
</ng-container>
